"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.prepareTransaction = void 0;
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var errors_1 = require("@ledgerhq/errors");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var account_1 = require("../../account");
var web3_1 = require("./api/chain/web3");
var errors_2 = require("./errors");
var logic_1 = require("./logic");
var utils_1 = require("./utils");
function deriveCommandDescriptor(mainAccount, tx, api) {
    return __awaiter(this, void 0, void 0, function () {
        var errors, model, memoBytes;
        return __generator(this, function (_a) {
            errors = {};
            model = tx.model;
            switch (model.kind) {
                case "transfer":
                case "token.transfer":
                    if (!tx.recipient) {
                        errors.recipient = new errors_1.RecipientRequired();
                    }
                    else if (mainAccount.freshAddress === tx.recipient) {
                        errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                    }
                    else if (!(0, logic_1.isValidBase58Address)(tx.recipient)) {
                        errors.recipient = new errors_1.InvalidAddress();
                    }
                    if (model.uiState.memo) {
                        memoBytes = Buffer.from(model.uiState.memo, "utf-8");
                        if (memoBytes.byteLength > logic_1.MAX_MEMO_LENGTH) {
                            errors.memo = errors.memo = new errors_2.SolanaMemoIsTooLong(undefined, {
                                maxLength: logic_1.MAX_MEMO_LENGTH
                            });
                            // LLM expects <transaction> as error key to disable continue button
                            errors.transaction = errors.memo;
                        }
                    }
                    if (Object.keys(errors).length > 0) {
                        return [2 /*return*/, toInvalidStatusCommand(errors)];
                    }
                    return [2 /*return*/, model.kind === "transfer"
                            ? deriveTransferCommandDescriptor(mainAccount, tx, model, api)
                            : deriveTokenTransferCommandDescriptor(mainAccount, tx, model, api)];
                case "token.createATA":
                    return [2 /*return*/, deriveCreateAssociatedTokenAccountCommandDescriptor(mainAccount, model, api)];
                default:
                    return [2 /*return*/, (0, utils_1.assertUnreachable)(model)];
            }
            return [2 /*return*/];
        });
    });
}
var prepareTransaction = function (mainAccount, tx, api) { return __awaiter(void 0, void 0, void 0, function () {
    var patch, errors, feeCalculator, _a, txToDeriveFrom, commandDescriptor, command, totalSpend, totalFees;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                patch = {};
                errors = {};
                if (!((_b = tx.feeCalculator) !== null && _b !== void 0)) return [3 /*break*/, 1];
                _a = _b;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, api.getTxFeeCalculator()];
            case 2:
                _a = (_d.sent());
                _d.label = 3;
            case 3:
                feeCalculator = _a;
                if (tx.feeCalculator === undefined) {
                    patch.feeCalculator = feeCalculator;
                    // LLM requires this field to be truthy to show fees
                    patch.networkInfo = true;
                }
                txToDeriveFrom = __assign(__assign({}, updateModelIfSubAccountIdPresent(tx)), { feeCalculator: feeCalculator });
                return [4 /*yield*/, deriveCommandDescriptor(mainAccount, txToDeriveFrom, api)];
            case 4:
                commandDescriptor = _d.sent();
                if (commandDescriptor.status === "invalid") {
                    return [2 /*return*/, toInvalidTx(tx, patch, commandDescriptor.errors, commandDescriptor.warnings)];
                }
                command = commandDescriptor.command;
                switch (command.kind) {
                    case "transfer": {
                        totalSpend = command.amount + feeCalculator.lamportsPerSignature;
                        if (mainAccount.balance.lt(totalSpend)) {
                            errors.amount = new errors_1.NotEnoughBalance();
                        }
                        break;
                    }
                    default: {
                        totalFees = feeCalculator.lamportsPerSignature + ((_c = commandDescriptor.fees) !== null && _c !== void 0 ? _c : 0);
                        if (mainAccount.balance.lt(totalFees)) {
                            errors.amount = new errors_1.NotEnoughBalance();
                        }
                    }
                }
                if (Object.keys(errors).length > 0) {
                    return [2 /*return*/, toInvalidTx(tx, patch, errors)];
                }
                patch.model = __assign(__assign({}, tx.model), { commandDescriptor: commandDescriptor });
                return [2 /*return*/, Object.keys(patch).length > 0
                        ? __assign(__assign({}, tx), patch) : tx];
        }
    });
}); };
exports.prepareTransaction = prepareTransaction;
var deriveTokenTransferCommandDescriptor = function (mainAccount, tx, model, api) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, subAccount, tokenIdParts, mintAddress, mintDecimals, senderAssociatedTokenAccountAddress, recipientDescriptor, fees, _a, txAmount;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errors = {};
                warnings = {};
                subAccount = (0, account_1.findSubAccountById)(mainAccount, model.uiState.subAccountId);
                if (!subAccount || subAccount.type !== "TokenAccount") {
                    throw new Error("subaccount not found");
                }
                tokenIdParts = subAccount.token.id.split("/");
                mintAddress = tokenIdParts[tokenIdParts.length - 1];
                mintDecimals = subAccount.token.units[0].magnitude;
                senderAssociatedTokenAccountAddress = (0, logic_1.decodeAccountIdWithTokenAccountAddress)(subAccount.id).address;
                if (tx.recipient === senderAssociatedTokenAccountAddress) {
                    errors.recipient = new errors_2.SolanaTokenRecipientIsSenderATA();
                    return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                }
                return [4 /*yield*/, getTokenRecipient(tx.recipient, mintAddress, api)];
            case 1:
                recipientDescriptor = _b.sent();
                if (recipientDescriptor instanceof Error) {
                    errors.recipient = recipientDescriptor;
                    return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                }
                if (!recipientDescriptor.shouldCreateAsAssociatedTokenAccount) return [3 /*break*/, 3];
                return [4 /*yield*/, api.getAssocTokenAccMinNativeBalance()];
            case 2:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = 0;
                _b.label = 4;
            case 4:
                fees = _a;
                if (!recipientDescriptor.shouldCreateAsAssociatedTokenAccount) return [3 /*break*/, 6];
                warnings.recipientAssociatedTokenAccount =
                    new errors_2.SolanaRecipientAssociatedTokenAccountWillBeFunded();
                return [4 /*yield*/, isAccountFunded(tx.recipient, api)];
            case 5:
                if (!(_b.sent())) {
                    warnings.recipient = new errors_2.SolanaAccountNotFunded();
                }
                _b.label = 6;
            case 6:
                if (!tx.useAllAmount && tx.amount.lte(0)) {
                    errors.amount = new errors_1.AmountRequired();
                    return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                }
                txAmount = tx.useAllAmount
                    ? subAccount.spendableBalance.toNumber()
                    : tx.amount.toNumber();
                if (txAmount > subAccount.spendableBalance.toNumber()) {
                    errors.amount = new errors_1.NotEnoughBalance();
                    return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                }
                return [2 /*return*/, {
                        status: "valid",
                        command: {
                            kind: "token.transfer",
                            ownerAddress: mainAccount.freshAddress,
                            ownerAssociatedTokenAccountAddress: senderAssociatedTokenAccountAddress,
                            amount: txAmount,
                            mintAddress: mintAddress,
                            mintDecimals: mintDecimals,
                            recipientDescriptor: recipientDescriptor,
                            memo: model.uiState.memo
                        },
                        fees: fees,
                        warnings: warnings
                    }];
        }
    });
}); };
function getTokenRecipient(recipientAddress, mintAddress, api) {
    return __awaiter(this, void 0, void 0, function () {
        var recipientTokenAccount, recipientAssociatedTokenAccountAddress, shouldCreateAsAssociatedTokenAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, web3_1.getMaybeTokenAccount)(recipientAddress, api)];
                case 1:
                    recipientTokenAccount = _a.sent();
                    if (recipientTokenAccount instanceof Error) {
                        throw recipientTokenAccount;
                    }
                    if (!(recipientTokenAccount === undefined)) return [3 /*break*/, 4];
                    if (!(0, logic_1.isEd25519Address)(recipientAddress)) {
                        return [2 /*return*/, new errors_2.SolanaAddressOffEd25519()];
                    }
                    return [4 /*yield*/, api.findAssocTokenAccAddress(recipientAddress, mintAddress)];
                case 2:
                    recipientAssociatedTokenAccountAddress = _a.sent();
                    return [4 /*yield*/, isAccountFunded(recipientAssociatedTokenAccountAddress, api)];
                case 3:
                    shouldCreateAsAssociatedTokenAccount = !(_a.sent());
                    return [2 /*return*/, {
                            walletAddress: recipientAddress,
                            shouldCreateAsAssociatedTokenAccount: shouldCreateAsAssociatedTokenAccount,
                            tokenAccAddress: recipientAssociatedTokenAccountAddress
                        }];
                case 4:
                    if (recipientTokenAccount.mint.toBase58() !== mintAddress) {
                        return [2 /*return*/, new errors_2.SolanaTokenAccountHoldsAnotherToken()];
                    }
                    if (recipientTokenAccount.state !== "initialized") {
                        return [2 /*return*/, new errors_2.SolanaTokenAccounNotInitialized()];
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/, {
                        walletAddress: recipientTokenAccount.owner.toBase58(),
                        shouldCreateAsAssociatedTokenAccount: false,
                        tokenAccAddress: recipientAddress
                    }];
            }
        });
    });
}
function deriveCreateAssociatedTokenAccountCommandDescriptor(mainAccount, model, api) {
    return __awaiter(this, void 0, void 0, function () {
        var token, tokenIdParts, mint, associatedTokenAccountAddress, fees;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = (0, cryptoassets_1.getTokenById)(model.uiState.tokenId);
                    tokenIdParts = token.id.split("/");
                    mint = tokenIdParts[tokenIdParts.length - 1];
                    return [4 /*yield*/, api.findAssocTokenAccAddress(mainAccount.freshAddress, mint)];
                case 1:
                    associatedTokenAccountAddress = _a.sent();
                    return [4 /*yield*/, api.getAssocTokenAccMinNativeBalance()];
                case 2:
                    fees = _a.sent();
                    return [2 /*return*/, {
                            status: "valid",
                            fees: fees,
                            command: {
                                kind: model.kind,
                                mint: mint,
                                owner: mainAccount.freshAddress,
                                associatedTokenAccountAddress: associatedTokenAccountAddress
                            }
                        }];
            }
        });
    });
}
function deriveTransferCommandDescriptor(mainAccount, tx, model, api) {
    return __awaiter(this, void 0, void 0, function () {
        var errors, warnings, recipientWalletIsUnfunded, fee, txAmount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errors = {};
                    warnings = {};
                    if (!(0, logic_1.isEd25519Address)(tx.recipient)) {
                        warnings.recipientOffCurve = new errors_2.SolanaAddressOffEd25519();
                    }
                    return [4 /*yield*/, isAccountFunded(tx.recipient, api)];
                case 1:
                    recipientWalletIsUnfunded = !(_a.sent());
                    if (recipientWalletIsUnfunded) {
                        warnings.recipient = new errors_2.SolanaAccountNotFunded();
                    }
                    if (!tx.useAllAmount && tx.amount.lte(0)) {
                        errors.amount = new errors_1.AmountRequired();
                        return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                    }
                    fee = tx.feeCalculator.lamportsPerSignature;
                    txAmount = tx.useAllAmount
                        ? bignumber_js_1["default"].max(mainAccount.balance.minus(fee), 0)
                        : tx.amount;
                    if (txAmount.plus(fee).gt(mainAccount.balance)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                        return [2 /*return*/, toInvalidStatusCommand(errors, warnings)];
                    }
                    return [2 /*return*/, {
                            status: "valid",
                            command: {
                                kind: "transfer",
                                sender: mainAccount.freshAddress,
                                recipient: tx.recipient,
                                amount: txAmount.toNumber(),
                                memo: model.uiState.memo
                            },
                            warnings: Object.keys(warnings).length > 0 ? warnings : undefined
                        }];
            }
        });
    });
}
function toInvalidTx(tx, patch, errors, warnings) {
    return __assign(__assign(__assign({}, tx), patch), { model: __assign(__assign({}, tx.model), { commandDescriptor: toInvalidStatusCommand(errors, warnings) }) });
}
function toInvalidStatusCommand(errors, warnings) {
    return {
        status: "invalid",
        errors: errors,
        warnings: warnings
    };
}
// if subaccountid present - it's a token transfer
function updateModelIfSubAccountIdPresent(tx) {
    if (tx.subAccountId) {
        return __assign(__assign({}, tx), { model: {
                kind: "token.transfer",
                uiState: __assign(__assign({}, tx.model.uiState), { subAccountId: tx.subAccountId })
            } });
    }
    return tx;
}
function isAccountFunded(address, api) {
    return __awaiter(this, void 0, void 0, function () {
        var balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.getBalance(address)];
                case 1:
                    balance = _a.sent();
                    return [2 /*return*/, balance > 0];
            }
        });
    });
}
//# sourceMappingURL=js-prepareTransaction.js.map